import React from 'react'
import { ErrorPage } from '../ErrorPage'

export const SomethingWentWrong = (props: { attribution: boolean }) => (
    <ErrorPage text={() => 'Oops! Something went wrong'} attribution={props.attribution} />
)
